import * as React from 'react';

import { getDisplayName } from 'components/hoc';
import { delayed } from 'lib/Job';

import { WithTrackerPropsType } from 'components/hoc/Cards/withTracker';
import { WithUiStatePropsType } from 'components/hoc/Cards/withUiState';
import { CardProps } from 'components/molecules/Card';
import { CardTypeTypes } from 'types/Card';

export type HandleClickHeartType = {
	type?: CardTypeTypes;
	buttonType: string;
	onAnimationDone: () => void;
};
export type HandleClickCloseType = {
	type?: CardTypeTypes;
	buttonType: string;
	onAnimationDone: () => void;
};

export type WithHandleProductProxyPropsType = CardProps & WithUiStatePropsType & WithTrackerPropsType;

export type WithHandleProductPropsType = {
	onClickHeart: (type: HandleClickHeartType) => void;
	onClickClose: (type: HandleClickCloseType) => void;
	isUiUpdatingHeart: boolean;
	isUiClosing: boolean;
};

export type WithHandleProductStateType = {
	isUiUpdatingHeart: boolean;
	isUiClosing: boolean;
};

export default function withHandleProduct<P extends object>(WrappedComponent: React.ComponentType<P>) {
	return class HandleProductProxy extends React.Component<
		P & WithHandleProductProxyPropsType,
		WithHandleProductStateType
	> {
		public static displayName = `withHandleProduct(${getDisplayName(WrappedComponent)})`;

		public state: WithHandleProductStateType = {
			isUiUpdatingHeart: false,
			isUiClosing: false,
		};

		public removeFocus() {
			if (document && document.activeElement !== null) {
				(document.activeElement as HTMLElement).blur();
			}
		}

		public handleClickHeart = ({ type, buttonType, onAnimationDone }: HandleClickHeartType) => {
			this.removeFocus();
			this.setState({ isUiUpdatingHeart: true }, () => {
				this.props.onCompleteCard(() => {
					delayed(() => {
						onAnimationDone();
						this.setState({ isUiUpdatingHeart: false });
					}, 1000);
				});
			});

			if (typeof type === 'string') {
				this.props.trackCardProductAction(buttonType);
			}
		};

		public handleClickClose = ({ type, buttonType, onAnimationDone }: HandleClickHeartType) => {
			this.setState({ isUiClosing: true }, () => {
				this.props.onCompleteCard(() => {
					delayed(() => {
						onAnimationDone();
						this.setState({ isUiClosing: false });
					}, 1000);
				});
			});

			if (typeof type === 'string') {
				this.props.trackCardProductAction(buttonType);
			}
		};

		public render() {
			return (
				<WrappedComponent
					onClickHeart={this.handleClickHeart}
					onClickClose={this.handleClickClose}
					isUiUpdatingHeart={this.state.isUiUpdatingHeart}
					isUiClosing={this.state.isUiClosing}
					{...this.props}
				/>
			);
		}
	};
}
